/* eslint-env browser, jquery */
/* global FeatureWidget */
import rg from 'modules/npm-component/require-global';
import template from './feature-widget.pug';
import tableTemplate from './features-table.pug';

export default function FeaturesPartial(options) {
  options = options || {};

  this.track = options.track;
}

FeaturesPartial.prototype.load = function(batch) {
  batch.push(done => {
    rg('//cdn.auth0.com/js/feature-widget/feature-widget-1.7.0.min.js', 'FeatureWidget', done);
  });
};

FeaturesPartial.prototype.activate = function() {
  this.$plans = $('[data-plan]');
  this.setFilterPlans('self_service');
};

FeaturesPartial.prototype.render = function() {
  const filterFeaturesThatAreAtLeastInOnePlan = FeatureWidget.filter.filterFeaturesThatAreAtLeastInOnePlan(
    this.filterPlans.bind(this)
  );
  const filterActiveFeatures = FeatureWidget.filter.filterActiveFeatures();

  this.$plans.each((i, planContainer) => {
    const $planContainer = $(planContainer);
    const planKey = $planContainer.data('plan');
    const $widgetContainer = $planContainer.find('.js-plan-features-container');

    const widget = new FeatureWidget({
      template: locals => template({ ...locals, ...{ planKey } }),
      filterPlans: this.filterPlans,
      filterFeatures(feature) {
        return (
          filterFeaturesThatAreAtLeastInOnePlan(feature) &&
          filterActiveFeatures(feature) &&
          !/users_count|employees_count|social_connections|enterprise_connections/.test(feature.key)
        );
      },
      sortPlans: FeatureWidget.sort.plansByNumberOfFeaturesTheyHave(false),
      sortFeatures: FeatureWidget.sort.featuresByNumberOfPlansTheyAre(true),
      sortTags: this.sortTags()
    });

    $widgetContainer.html(widget.render());

    // Features table

    const $tableContainer = $('.js-features-table-container');

    const table = new FeatureWidget({
      template: locals => tableTemplate({ ...locals }),
      filterPlans: this.filterPlans,
      filterFeatures(feature) {
        return filterFeaturesThatAreAtLeastInOnePlan(feature) && filterActiveFeatures(feature);
      },
      sortPlans: FeatureWidget.sort.plansByNumberOfFeaturesTheyHave(false),
      sortFeatures: FeatureWidget.sort.featuresByNumberOfPlansTheyAre(true),
      sortTags: this.sortTags()
    });

    $tableContainer.html(table.render());
  });
};

FeaturesPartial.prototype.sortTags = function() {
  const defaultSorter = FeatureWidget.sort.tagsByNumberOfFeatures(true);

  // we want to place the category 'Support' just after 'Authentication'
  // the rest of the categories will follow the featuresByNumberOfPlansTheyAre
  // sorter
  return function(tag1, tag2) {
    if (tag1.key === 'Authentication' && tag2.key === 'Support') {
      return -1;
    }

    if (tag1.key === 'Support' || tag2.key === 'Support') {
      return 1;
    }

    return defaultSorter(tag1, tag2);
  };
};

FeaturesPartial.prototype.setFilterPlans = function(type) {
  this.currentMode = type;

  this.filterPlans = function(plan) {
    const isNewPlan = ~['free', 'developer', 'developer-pro', 'enterprise'].indexOf(plan.plan);
    return plan.type.toLowerCase() === type && isNewPlan;
  };
};



// WEBPACK FOOTER //
// ./src/pages/ab-variants/new-pricing/partials/features/features-partial.js